import React from "react";

export default function LoanStepCard({
  number,
  heading,
  subtext,
  imgSrc,
  isOverlay = false,
  overlayImg = "",
  background,
  height,
  width,
  rounded,
}) {
  return (
    <div className="rounded-3xl relative box-border pl-5 pt-3 border-1 border-[#E0CFC2] shadow-sm bg-white flex flex-col justify-between min-h-[420px] xs:min-h-[330px] sm:min-h-[450px] overflow-visible">
      {/* Content */}
      <div className="p-6 xs:p-3 flex flex-col gap-3 flex-grow z-10">
        <div className="flex justify-between items-start">
          <h3 className="text-2xl xs:text-lg font-atkinson max-w-[70%] text-black">
            {heading}
          </h3>
          <span className="text-[#E0CFC2] font-bomstad-thin font-semibold text-4xl sm:3xl ">
            {number}
          </span>
        </div>
        <p className="text-lg max-w-[90%] xs:text-sm text-gray-600">{subtext}</p>
      </div>

      {/* Image background */}
      <div
        className="absolute bottom-0  w-[87%] xs:w-[87%] right-0 h-1/2 xs:h-[45%] rounded-tl-3xl rounded-br-3xl  z-[0]"
        style={{ background }}
      >
        <img
          src={imgSrc}
          alt={heading}
          className={`absolute bottom-0 ${rounded}  rounded-br-3xl z-[20]`}
          style={{ height: height || "100%", width: width || "100%" }}
        />
        {isOverlay && overlayImg && (
          <img
            src={overlayImg}
            alt="Overlay"
            className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[150px] w-[150px] z-[20]"
          />
        )}
      </div>
    </div>
  );
}
